'use strict';

exports.__esModule = true;
exports.phasesConfigValues = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _env = require('./env');

var _performance = require('./performance/performance');

var _performance2 = _interopRequireDefault(_performance);

var _times = require('./times/times');

var _times2 = _interopRequireDefault(_times);

var _dataSource = require('./data-source/data-source');

var _dataSource2 = _interopRequireDefault(_dataSource);

var _sessionManager = require('./session-manager/session-manager');

var _sessionManager2 = _interopRequireDefault(_sessionManager);

var _loadingPhases = require('./loading-phases/loading-phases');

var _loadingPhases2 = _interopRequireDefault(_loadingPhases);

var _reporterFactory = require('./reporter/reporter-factory');

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _dataItems = require('./data-items/data-items');

var _loader = require('./presets/loader');

var _presetsTypes = require('./presets/presets-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var callHook = function callHook(hook, hookArgs) {
  if (hook) {
    return hook(hookArgs);
  }
};

/**
 * Base Logger
 * @param appName
 * @param appVersion
 * @param reporter
 *
 * Params object properties:
 * @param baseUrl
 * @param appId
 * @param disableAutoLoadFinish
 * @param phasesConfig
 * @param interactionTimeout
 * @param timeoutHook
 * @param startHook
 * @param endHook
 * @param artifactData
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */

var BaseLogger = function () {
  function BaseLogger(appName, appVersion, reporter, params) {
    _classCallCheck(this, BaseLogger);

    var defaultParams = {
      appId: null,
      widgetId: null,
      metasiteId: null,
      sessionId: _sessionManager2.default.getSessionId(),
      isServerSide: null,
      disableAutoLoadFinish: false,
      phasesConfig: phasesConfigValues.SEND_ON_START,
      interactionTimeout: null,
      timeoutHook: null,
      startHook: null,
      endHook: null,
      isPersistent: false,
      corrId: (0, _v2.default)(),
      preset: (0, _loader.presetLoader)(), // for testing purposes only:/
      presetType: _presetsTypes.presetsTypes.DEFAULT,
      customParams: {}
    };

    var paramsWithDefaults = Object.assign({}, defaultParams, params);
    this.appName = appName;
    this.appVersion = appVersion;
    this.appId = paramsWithDefaults.appId;
    this.widgetId = paramsWithDefaults.widgetId;
    this.metasiteId = paramsWithDefaults.metasiteId;

    this.corrId = paramsWithDefaults.corrId;
    this.isServerSide = paramsWithDefaults.isServerSide;
    this.params = { sessionId: paramsWithDefaults.sessionId };
    this._customParams = Object.assign({}, paramsWithDefaults.customParams);
    this.disableAutoLoadFinish = paramsWithDefaults.disableAutoLoadFinish;
    this.phasesConfig = paramsWithDefaults.phasesConfig;
    this._appLoadedCalled = {};
    this._appStartLoadCalled = {};
    this._preset = paramsWithDefaults.preset;
    this._presetType = paramsWithDefaults.presetType;
    this.dataItems = (0, _dataItems.createDataItems)(this.sessionId, this._preset);
    this.reporter = reporter || (0, _reporterFactory.create)({ preset: this._preset });
    this.loadingPhases = new _loadingPhases2.default(appName);
    this.dataSourceBase = new _dataSource2.default();
    this.dataSourceBase.addItem(this.dataItems.appName({
      appName: appName,
      isServerSide: this.isServerSide
    })).addItem(this.dataItems.dataItem({ corrId: this.corrId }));

    if (params && params.artifactData) {
      this.dataSourceBase.addItem(this.dataItems.artifact(params.artifactData));
    }

    this._outgoingInteractions = {};
    this.interactionTimeout = paramsWithDefaults.interactionTimeout;
    this.timeoutHook = paramsWithDefaults.timeoutHook;
    this.startHook = paramsWithDefaults.startHook;
    this.endHook = paramsWithDefaults.endHook;
    this.isPersistent = paramsWithDefaults.isPersistent;

    this.times = new _times2.default(appName);
  }

  BaseLogger.prototype._report = function _report(dataSource, reporterEndpoint) {
    return this.reporter.report(dataSource.mergeItems(), reporterEndpoint);
  };

  BaseLogger.prototype.getAppName = function getAppName() {
    return this.appName;
  };

  BaseLogger.prototype.getAppVersion = function getAppVersion() {
    return this.appVersion;
  };

  BaseLogger.prototype.getReporter = function getReporter() {
    return this.reporter;
  };

  BaseLogger.prototype.getParam = function getParam(paramName) {
    return this.params[paramName];
  };

  BaseLogger.prototype._isDisableAutoLoadFinish = function _isDisableAutoLoadFinish() {
    return this.disableAutoLoadFinish;
  };

  BaseLogger.prototype.isDisableAutoLoadFinish = function isDisableAutoLoadFinish() {
    return this._isDisableAutoLoadFinish();
  };

  BaseLogger.prototype.reportNetworkAnalysis = function reportNetworkAnalysis() {
    var _this = this;

    var resources = _performance2.default.getResources();
    setTimeout(function () {
      try {
        var resourceDataItem = _this.dataItems.resource();

        var analysis = resourceDataItem.performNetworkAnalysis(resources);
        if (!analysis) {
          return;
        }
        var dataSource = _this.dataSource.addItem(resourceDataItem).addItem(analysis);

        _this._report(dataSource);
      } catch (e) {
        console.error('[fedops] Failed to report resource metrics', e);
      }
    }, 1000);
  };

  /**
   * Manual report for widget load start - Should only be used if your widget doesn't have its own .vm / .ejs file
   * Call this method at the earliest point possible when your widget starts loading.
   */


  BaseLogger.prototype.appLoadStarted = function appLoadStarted() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref.appId;

    if (appId && this._appStartLoadCalled[appId] || !appId && this._appStartLoadCalled[this.appName]) {
      return;
    }

    BaseLogger._markAppLoadStarted(this.appName);
    this._appStartLoadCalled[appId || this.appName] = true;
    var appIdForDuration = appId || this.appId;
    this.times.setLoadStarted(appIdForDuration ? {
      appId: appId || this.appId
    } : {});

    var dataSource = this.dataSource.addItem(this.dataItems.biAppLoadStart()).addItem(this.dataItems.appContext({
      appId: appId || this.appId,
      widgetId: this.widgetId,
      isServerSide: this.isServerSide
    }));

    if (appId) {
      dataSource.addItem(this.dataItems.appName({
        appName: appId,
        isServerSide: this.isServerSide
      }));
    }

    return this._report(dataSource, this._getEndpoint());
  };

  BaseLogger.prototype._isCustomParamsAllowed = function _isCustomParamsAllowed(presetType) {
    return presetType === _presetsTypes.presetsTypes.DEFAULT;
  };

  /**
   * Final phase.
   * Call this method when your application finishes loading and after all custom phases.
   * @param appId
   * @param customParams is an object
   */


  BaseLogger.prototype.appLoaded = function appLoaded() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        appId = _ref2.appId,
        customParams = _ref2.customParams;

    if (appId && this._appLoadedCalled[appId] || !appId && this._appLoadedCalled[this.appName]) {
      return;
    }

    BaseLogger._clearLoadTimeout();
    BaseLogger._markAndMeasureAppLoad(this.appName);
    this._appLoadedCalled[appId || this.appName] = true;

    this._sendLastAppLoadPhaseIfNeeded();
    this.reportNetworkAnalysis();

    var appIdForDuration = appId || this.appId;
    var dataSource = this.dataSource.addItem(this.dataItems.biAppLoadFinish()).addItem(this.dataItems.appContext({
      appId: appId || this.appId,
      widgetId: this.widgetId,
      isServerSide: this.isServerSide
    })).addItem(this.dataItems.duration(this.times.getAppLoadTime(appIdForDuration ? {
      appId: appId || this.appId
    } : {})).setFirstRequestDuration(this.times.getFirstRequestDuration()));

    if (appId) {
      dataSource.addItem(this.dataItems.appName({
        appName: appId,
        isServerSide: this.isServerSide
      }));
    }

    if (this._isCustomParamsAllowed(this._presetType)) {
      var customParamsObj = typeof customParams === 'string' ? JSON.parse(customParams) : customParams;
      customParams = Object.assign({}, this._customParams, customParamsObj);

      if (Object.keys(customParams).length > 0) {
        var stringifiedCustomParams = JSON.stringify(customParams);
        dataSource.addItem(this.dataItems.customParams(stringifiedCustomParams));
      }
    }

    if (this.phasesConfig === phasesConfigValues.SEND_ON_APP_LOADED) {
      var phasesOfApp = this.loadingPhases.getPhases({ appId: appId });
      if (phasesOfApp.length > 0) {
        dataSource.addItem(this.dataItems.loadingPhaseCollection(phasesOfApp));
      }
    }

    return this._report(dataSource, this._getEndpoint());
  };

  /**
   * Start of an app loading phase, reports end of previous phase if configured
   * Sends phase event (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
   * @param name of the step
   * @param appId that the step belongs to
   * @param widgetId that the step belongs to
   */


  BaseLogger.prototype.appLoadingPhaseStart = function appLoadingPhaseStart(name) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        appId = _ref3.appId,
        widgetId = _ref3.widgetId;

    if (this.phasesConfig === phasesConfigValues.SEND_ON_START) {
      this.loadingPhases.createCodeParsingPhaseIfNotExist({ appId: appId, widgetId: widgetId });
    }

    this.loadingPhases.saveLoadingPhase({ name: name, appId: appId, widgetId: widgetId });
    this._sendPreviousPhaseIfNeeded(name, { appId: appId, widgetId: widgetId });

    _performance2.default.mark('[fedops] ' + name + ' started');
  };

  BaseLogger.prototype._sendPreviousPhaseIfNeeded = function _sendPreviousPhaseIfNeeded(name) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        appId = _ref4.appId,
        widgetId = _ref4.widgetId;

    if (this.phasesConfig === phasesConfigValues.SEND_ON_START) {
      var previousPhase = this.loadingPhases.getPhasePreviousTo({
        name: name,
        appId: appId,
        widgetId: widgetId
      });

      _performance2.default.mark('[fedops] ' + previousPhase.name + ' finished');

      var loadingPhaseDataItem = this.dataItems.loadingPhasePrefixed(previousPhase);
      var loadingPhaseBiItem = this.dataItems.biLoadPhase();

      var dataSource = this.dataSource.addItem(loadingPhaseDataItem).addItem(loadingPhaseBiItem);

      this._report(dataSource);
    }
  };

  /**
   * End of an app loading phase, reports end of previous phase
   * Sends phase event (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
   * @param name of the step
   * @param appId that the step belongs to
   * @param widgetId that the step belongs to
   * @param widgetArray that are related to this step
   */


  BaseLogger.prototype.appLoadingPhaseFinish = function appLoadingPhaseFinish(name) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        appId = _ref5.appId,
        widgetId = _ref5.widgetId,
        widgetArray = _ref5.widgetArray;

    if (this.phasesConfig === phasesConfigValues.SEND_ON_START) {
      throw new Error('To use appLoadingPhaseFinish you must create the logger with the "phasesConfig: SEND_ON_FINISH or SEND_ON_APP_LOADED" param');
    }

    _performance2.default.mark('[fedops] ' + name + ' finished');

    if (this.phasesConfig === phasesConfigValues.SEND_ON_APP_LOADED) {
      this.loadingPhases.endLoadingPhase({
        name: name,
        appId: appId,
        widgetId: widgetId,
        widgetArray: widgetArray
      });
    } else {
      var loadingPhase = this.loadingPhases.getAppLoadingPhaseData({
        name: name,
        appId: appId,
        widgetId: widgetId
      });

      if (!loadingPhase) {
        throw new Error('Cannot report end of a phase that wasn\'t started. Phase ' + name + ' doesn\'t exist');
      }

      var loadingPhaseDataItem = this.dataItems.loadingPhase(loadingPhase);
      var loadingPhaseBiItem = this.dataItems.biLoadPhase();
      var eventContextDataItem = this.dataItems.appContext({
        appId: appId,
        widgetId: widgetId,
        widgetArray: widgetArray,
        isServerSide: this.isServerSide
      });

      var dataSource = this.dataSource.addItem(loadingPhaseDataItem).addItem(loadingPhaseBiItem).addItem(eventContextDataItem);

      return this._report(dataSource, this._getEndpoint());
    }
  };

  BaseLogger.prototype._getEndpoint = function _getEndpoint() {
    return this.isPersistent ? this._preset.persistentEndpoint : this._preset.nonPersistentEndpoint;
  };

  BaseLogger.prototype._sendLastAppLoadPhaseIfNeeded = function _sendLastAppLoadPhaseIfNeeded() {
    var appLoadingPhase = this.loadingPhases.getNextPhaseToReport();
    var shouldReportLastPhase = this.phasesConfig === phasesConfigValues.SEND_ON_START && appLoadingPhase && appLoadingPhase.name !== _loadingPhases.CODE_PARSING_PHASE_NAME;

    if (shouldReportLastPhase) {
      this._report(this.dataSource.addItem(this.dataItems.loadingPhasePrefixed(appLoadingPhase)).addItem(this.dataItems.biLoadPhase()));
    }
  };

  BaseLogger._clearLoadTimeout = function _clearLoadTimeout() {
    if ((0, _env.env)() && (0, _env.env)().fedops && typeof (0, _env.env)().fedops.clearLoadTimeout === 'function') {
      (0, _env.env)().fedops.clearLoadTimeout();
    }
  };

  BaseLogger.prototype.clearResourceTimings = function clearResourceTimings() {
    _performance2.default.clearResourceTimings();
  };

  BaseLogger._markAppLoadStarted = function _markAppLoadStarted(appName) {
    _performance2.default.mark('[fedops] ' + appName + ' app-load-started');
  };

  BaseLogger._markAndMeasureAppLoad = function _markAndMeasureAppLoad(appName) {
    _performance2.default.mark('[fedops] ' + appName + ' app-loaded');

    try {
      _performance2.default.measure('[fedops] ' + appName + ' app-loaded', '[fedops] ' + appName + ' app-load-started', '[fedops] ' + appName + ' app-loaded');
    } catch (e) {}
  };

  /**
   * Custom interaction start (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/15)
   * @param {String} interactionName  interaction name
   */


  BaseLogger.prototype.interactionStarted = function interactionStarted(interactionName) {
    var _this2 = this;

    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        interactionTimeout = _ref6.interactionTimeout,
        startHook = _ref6.startHook,
        timeoutHook = _ref6.timeoutHook;

    _performance2.default.mark(interactionName + ' started');
    var scheduleTimeoutEvent = function scheduleTimeoutEvent() {
      if (interactionTimeout || _this2.interactionTimeout) {
        return setTimeout(function () {
          var dataSource = _this2.dataSource.addItem({ interactionName: interactionName }).addItem({ errorType: 'timeout' }).addItem(_this2.dataItems.biError());

          _this2._report(dataSource);
          callHook(timeoutHook || _this2.timeoutHook, {
            name: interactionName,
            timeout: interactionTimeout || _this2.interactionTimeout
          });
        }, interactionTimeout || _this2.interactionTimeout);
      }
    };

    var dataSource = this.dataSource.addItem({ name: interactionName }).addItem(this.dataItems.biInteractionStart());

    this._outgoingInteractions[interactionName] = {
      timestamp: _performance2.default.now(),
      timeout: interactionTimeout || this.interactionTimeout
    };
    this._report(dataSource);
    callHook(startHook || this.startHook, { name: interactionName });

    var timeoutId = scheduleTimeoutEvent();
    return {
      timeoutId: timeoutId
    };
  };

  /**
   * Custom interaction end (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/16)
   * @param {String} interactionName  interaction name
   */


  BaseLogger.prototype.interactionEnded = function interactionEnded(interactionName) {
    var _this3 = this;

    var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        timeoutId = _ref7.timeoutId,
        endHook = _ref7.endHook;

    if (this._outgoingInteractions[interactionName]) {
      _performance2.default.mark(interactionName + ' ended');
      _performance2.default.measure(interactionName + ' duration', interactionName + ' started', interactionName + ' ended');
    }

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    var getInteractionFromWindowIfPresent = function getInteractionFromWindowIfPresent(actualEnv) {
      return actualEnv.fedops && actualEnv.fedops.apps && actualEnv.fedops.apps[_this3.appName] && actualEnv.fedops.apps[_this3.appName].interactions && actualEnv.fedops.apps[_this3.appName].interactions[interactionName];
    };

    var interaction = this._outgoingInteractions[interactionName] || getInteractionFromWindowIfPresent((0, _env.env)());
    var duration = interaction ? Math.floor(_performance2.default.now() - interaction.timestamp) : '';

    callHook(endHook || this.endHook, {
      name: interactionName,
      duration: duration,
      timeout: this._outgoingInteractions[interactionName] && this._outgoingInteractions[interactionName].timeout
    });

    var dataSource = this.dataSource.addItem({ name: interactionName }).addItem({ duration: duration }).addItem(this.dataItems.biInteractionEnd());

    delete this._outgoingInteractions[interactionName];

    this._report(dataSource);
  };

  BaseLogger.prototype.getLoggerForWidget = function getLoggerForWidget(_ref8) {
    var appName = _ref8.appName,
        appId = _ref8.appId,
        widgetId = _ref8.widgetId,
        version = _ref8.version,
        timeoutHook = _ref8.timeoutHook,
        startHook = _ref8.startHook,
        endHook = _ref8.endHook,
        useGlobalLogger = _ref8.useGlobalLogger;

    var widgetAppName = appName || appId + '_' + widgetId;
    var widgetVersion = version || this.getAppVersion();
    var reporter = useGlobalLogger ? this.reporter : (0, _reporterFactory.create)({
      biLoggerFactory: this.reporter.factory,
      preset: this._preset
    });

    var config = {
      isServerSide: this.isServerSide,
      appId: appId,
      widgetId: widgetId,
      sessionId: this.sessionId,
      phasesConfig: phasesConfigValues.SEND_ON_START,
      isPersistent: this.isPersistent,
      timeoutHook: timeoutHook,
      startHook: startHook,
      endHook: endHook,
      customParams: this._customParams
    };

    return new BaseLogger(widgetAppName, widgetVersion, reporter, config);
  };

  _createClass(BaseLogger, [{
    key: 'dataSource',
    get: function get() {
      return this.dataSourceBase.clone();
    }
  }, {
    key: 'sessionId',
    get: function get() {
      return this.getParam('sessionId');
    },
    set: function set(sessionId) {
      this.params['sessionId'] = sessionId;
    }
  }]);

  return BaseLogger;
}();

exports.default = BaseLogger;
var phasesConfigValues = exports.phasesConfigValues = {
  SEND_ON_START: 'SEND_ON_START',
  SEND_ON_FINISH: 'SEND_ON_FINISH',
  SEND_ON_APP_LOADED: 'SEND_ON_APP_LOADED'
};